var React = require('react');

function IconCheck (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9 16.172l10.594-10.594 1.406 1.406-12 12-5.578-5.578 1.406-1.406z"}));
}

IconCheck.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"currentColor"};

module.exports = IconCheck;

IconCheck.default = IconCheck;
